import React from 'react';
import MultimediaCompShowcase from '../Views/MultimediaCompShowcase';

/**
 * MultimediaCompDemoView - Route component for the Multimedia Comp Showcase
 * Simple wrapper that renders the MultimediaCompDemo component
 */
const MultimediaCompShowcaseView = () => {
  return <MultimediaCompShowcase />;
};

export default MultimediaCompShowcaseView;
